// Module
var code = "<a class=\"text-sm sps-btn sps-btn-outline btn-color-consult-screen\" data-bind=\"style: _style\"> <i class=\"fa fa-desktop\" align=\"center\"></i> <!-- ko text: _labels.CONSULT --><!-- /ko --> </a>";
// Exports
export default code;